export default "__VITE_ASSET__BdbPzSzc__"